export enum CAMPAIGN_NAME {
    KAZAKH_PEAKS = 'Казахские Вершины 2.0',
    WORLD_WANDERERS = 'World Wanderers',
}
